export interface NewsItem {
  id: string;
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  tag: string;
  date: string;
  views: number;
  comments: number;
  hot: boolean;
  exclusive: boolean;
  summary: string;
  cover: string;
  alt: string;
  author: string;
  content: string[];
}

export const CATEGORIES = [
  { name: "全部", slug: "all" },
  { name: "独家爆料", slug: "exclusive" },
  { name: "明星动态", slug: "stars" },
  { name: "热剧追踪", slug: "drama" },
  { name: "音乐现场", slug: "music" },
  { name: "综艺圈", slug: "variety" },
];

export const NEWS: NewsItem[] = [
  {
    id: "n01",
    slug: "first-hand-gala-backstage",
    title: "独家直击：年度盛典后台三小时，明星们没说出口的真心话",
    category: "独家爆料",
    categorySlug: "exclusive",
    tag: "现场直击",
    date: "2026-09-08",
    views: 128600,
    comments: 3420,
    hot: true,
    exclusive: true,
    summary:
      "红毯外的后台到底什么样？我们带着镜头躲进化妆间与休息区，记录下颁奖礼前最真实的三个小时——有人对着镜子反复练获奖感言，有人偷吃工作人员的小零食，也有人对着手机发了好久的呆。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20backstage%20of%20a%20grand%20entertainment%20award%20ceremony%2C%20glowing%20vanity%20mirror%20lights%2C%20costume%20racks%20with%20sequin%20gowns%2C%20soft%20warm%20ambient%20glow%2C%20candid%20atmosphere%2C%20cinematic%20editorial%20photography&width=1600&height=900&seq=hero-gala-x1&orientation=landscape",
    alt: "年度盛典后台化妆间现场直击图",
    author: "瓜姐",
    content: [
      "晚上六点，红毯区的快门声还没停歇，我们便沿着侧廊钻进了盛典的B区后台。这里没有镁光灯，没有应援，只有密密麻麻的衣架、堆满化妆包的梳妆台，以及此起彼伏的耳机提示音。",
      "距离颁奖礼开场还有三小时。一位刚走下红毯的新人演员把礼服裙摆拢到椅子上，对着镜子补了整整二十分钟的口红。她小声告诉我们，这是她第一次被提名，紧张得连晚饭都不敢吃，怕礼服勒出褶皱。",
      "转角处的休息区，有人正趁着无人注意，从口袋里掏出一袋独立包装的小饼干。也许是担心被拍到尴尬，他一口一个塞得飞快，末了还冲镜头比了个「嘘」的手势——这一幕，恰恰比任何舞台上的光鲜都更有人情味。",
      "我们没能进入更私密的主咖休息室，但透过半掩的门缝，还是瞥见一位资深前辈正反复默念一段感言。获奖与否尚未揭晓，可那份认真的仪式感，已经足够动人。",
      "颁奖礼正式开始后，后台归于安静。那些被镁光灯放大的情绪，在这里褪去包装，只剩下最真实的紧张、期待与小小的雀跃。而这些，正是我们独家镜头想要替你留住的东西。",
    ],
  },
  {
    id: "n02",
    slug: "drama-late-night-record-seventeen",
    title: "热剧《雾城夜谈》杀青复盘：那场十七次重拍的雨戏背后",
    category: "热剧追踪",
    categorySlug: "drama",
    tag: "片场手记",
    date: "2026-09-07",
    views: 89300,
    comments: 1560,
    hot: true,
    exclusive: false,
    summary:
      "一场只有两分钟、全程雨中的诀别戏，剧组却拍了整整十七遍。导演为什么死磕不放？主演又经历了怎样的情绪消耗？我们跟组三天，替你拼出这场戏的真实成本。",
    cover:
      "https://readdy.ai/api/search-image?query=Night%20rain%20scene%20on%20a%20film%20set%2C%20neon%20lights%20reflecting%20on%20wet%20city%20street%2C%20actor%20standing%20in%20rain%20with%20coat%2C%20cinematic%20blue%20hour%20atmosphere%2C%20film%20crew%20silhouettes%2C%20dramatic%20moody%20lighting&width=1200&height=760&seq=drama-rain-x1&orientation=landscape",
    alt: "热剧雾城夜谈雨戏片场剧照",
    author: "老周",
    content: [
      "凌晨一点半，城市开始入睡，拍摄现场却刚进入最紧张的时刻。这场戏要拍的，是男女主角在大雨中彻底告别——没有台词，只有眼神、雨声和一把落在地上的伞。",
      "导演的要求近乎苛刻：第一遍，他说情绪「不够决绝」；第三遍，又批评「用力过猛」；到第七遍，连男主角自己都忍不住问，是不是自己理解错了角色。",
      "我们注意到，导演其实每一遍都在微调机位与雨量。他解释，真正的诀别不该是嚎啕大哭，而是那句「我走了」之后，谁都没回头时喉咙里那一下难以察觉的哽咽。",
      "到第十二遍，全组都安静了。雨打到第十六遍时，两位演员已经浑身湿透，嘴唇发白，可眼神里的东西终于对了。导演在监视器前沉默许久，只轻轻说了句「够了」——那一刻没有人欢呼，但所有人都松了一口气。",
      "一场两分钟的戏，最终耗时近七个小时。热剧之所以是热剧，或许正是因为这十七次重拍里，藏着主创对「真实」近乎偏执的追求。",
    ],
  },
  {
    id: "n03",
    slug: "singer-lin-xia-new-album",
    title: "唱作人林夏新专辑首发：用十二首歌，讲完一场没说出口的告别",
    category: "音乐现场",
    categorySlug: "music",
    tag: "新专首发",
    date: "2026-09-06",
    views: 76400,
    comments: 980,
    hot: false,
    exclusive: false,
    summary:
      "暌违三年，林夏带着全新概念专辑回归。这一次，他放弃了讨好市场的旋律，选择把一段长达十年的遗憾写成一张完整的唱片。我们聊了聊那些藏在歌词角落的真实细节。",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20recording%20studio%20with%20acoustic%20guitar%20and%20microphone%2C%20warm%20desk%20lamp%20light%2C%20sheet%20music%20and%20vinyl%20records%20scattered%2C%20soft%20golden%20tones%2C%20intimate%20editorial%20music%20photography&width=1200&height=760&seq=music-album-x1&orientation=landscape",
    alt: "唱作人林夏新专辑录音室宣传照",
    author: "音浪编辑部",
    content: [
      "新专辑没有序曲、没有串场，十二首歌如同十二封信，被林夏按时间顺序一封封拆开。他说，如果上一张专辑是写给外界的宣言，那么这一张，是终于敢写给自己看的日记。",
      "第一主打歌《未寄出的信》在预告阶段就引发了大量讨论。林夏坦言，副歌那句「早知道那天该多说一句」，是他写完时坐在琴凳上哭了很久才敢录下来的。",
      "为了还原真实质感，他没有请专业和声团，而是把自己少年时期录下的旧磁带声音，小心翼翼地铺进音轨深处。第一次混音时，制作人几乎听不见那段声音，他却坚持要留下——「它很轻，但那是属于我的时间」。",
      "新专辑上线首日便空降多个平台热搜。歌迷们逐句解码歌词，把他藏在声波里的小彩蛋翻了个底朝天。对林夏而言，这或许不是一张「好卖」的专辑，但一定是他最诚实的一张。",
      "「告别不一定需要理由，」他在专访最后说，「但把它唱出来，我才能真的往前走。」",
    ],
  },
  {
    id: "n04",
    slug: "variety-cooking-show-return",
    title: "慢综艺《烟火小馆》第三季回归：流量之外的真诚有救吗？",
    category: "综艺圈",
    categorySlug: "variety",
    tag: "节目观察",
    date: "2026-09-05",
    views: 61200,
    comments: 2044,
    hot: true,
    exclusive: false,
    summary:
      "当内娱综艺都在卷游戏、卷对抗、卷话题度时，《烟火小馆》却坚持让六位常驻嘉宾围着一张灶台慢慢做饭、慢慢聊天。第三季口碑逆势上涨，它的方法论到底是什么？",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20rustic%20kitchen%20in%20a%20small%20mountain%20village%20restaurant%2C%20celebrities%20cooking%20around%20a%20large%20wooden%20table%2C%20steam%20rising%20from%20wok%2C%20golden%20afternoon%20light%2C%20cozy%20candid%20reality%20show%20atmosphere&width=1200&height=760&seq=variety-kitchen-x1&orientation=landscape",
    alt: "慢综艺烟火小馆灶台做饭画面",
    author: "阿岚",
    content: [
      "《烟火小馆》第三季开播时并不被看好。没有烧钱的舞美、没有高难度的闯关任务，节目组甚至允许嘉宾在厨房里安静地切十分钟菜而不加任何花字。",
      "然而豆瓣评分不降反升。观众发现，当镜头不再催促，人与人之间那些微小的体谅——帮忙扶稳锅盖的手、把最后一块肉夹给别人的筷子——反而成了最动人的「名场面」。",
      "总导演在采访里说，前两季他们也在摸索，是否真的可以放弃「制造冲突」这套成熟工业逻辑。直到有一期，一位嘉宾做糊了红烧肉，全桌人没有嘲笑，而是认真讨论起补救方案，他们才确定这条路走得通。",
      "当然，也有争议的声音认为这是「炒冷饭」「卖情怀」。但无可否认的是，当其他节目用二倍速看仍嫌拖沓时，愿意二倍速倒退回去看细节的，恰恰是《烟火小馆》。",
      "慢，从来不是注水。它只是把被快节奏偷走的时间，重新还给了人与人之间的温度。这大概就是它口碑逆袭的全部秘密。",
    ],
  },
  {
    id: "n05",
    slug: "actor-zhang-liu-backstreet",
    title: "影帝张旸的低调假期：菜市场、旧书店与一杯没喝完的咖啡",
    category: "明星动态",
    categorySlug: "stars",
    tag: "人物专访",
    date: "2026-09-04",
    views: 54800,
    comments: 730,
    hot: false,
    exclusive: false,
    summary:
      "刚拿下电影节的影帝，没有选择度假海岛，而是回到老家巷子里的旧书店泡了整整一个下午。他说，戏演得越久，越需要回到生活的粗粝里去找答案。",
    cover:
      "https://readdy.ai/api/search-image?query=Candid%20portrait%20of%20a%20middle%20aged%20asian%20actor%20in%20casual%20clothes%20browsing%20old%20books%20in%20a%20cozy%20vintage%20bookstore%2C%20warm%20window%20light%2C%20relaxed%20everyday%20atmosphere%2C%20documentary%20style&width=1200&height=760&seq=stars-casual-x1&orientation=landscape",
    alt: "影帝张旸在旧书店看书的日常画面",
    author: "小路",
    content: [
      "上周刚在电影节捧回最佳男主角的张旸，并没有出现在任何一个庆功派对上。有网友在老家老街的菜市场偶遇他，他正蹲在摊位前，认真挑一把时令青菜，和摊主聊得像是老邻居。",
      "第二天，有人又在巷口那家开了二十年的旧书店里拍到他。老板说，张旸一来就是一下午，也不怎么说话，就坐在靠窗的位置，翻那些泛黄的小说，偶尔在本子上记点什么。",
      "「戏演得越久，越觉得自己懂的东西太少。」张旸在随后的专访里这样解释。他坦言，聚光灯下的掌声容易让人漂浮，只有回到这些具体的、带着烟火气的生活细节里，他才能重新抓住表演的锚点。",
      "那杯没喝完的咖啡，是他在书店角落留到打烊的。老板说，他走的时候把书放回原处，又把椅子推进桌下，动作安静得像他演过的某个角色。",
      "或许真正的影帝，从来不在红毯上，而在那些无人注意、却认真生活的瞬间里。",
    ],
  },
  {
    id: "n06",
    slug: "exclusive-festival-unreleased",
    title: "独家：音乐节后台那十分钟，没人愿意剪掉的失控瞬间",
    category: "独家爆料",
    categorySlug: "exclusive",
    tag: "独家",
    date: "2026-09-03",
    views: 98500,
    comments: 2780,
    hot: true,
    exclusive: true,
    summary:
      "演出正式开始前，一支摇滚乐队的鼓手因为设备故障情绪崩溃，吉他手把演出服借给了走错舞台的观众。这些没能播出的花絮，组成了音乐节最真实的B面。",
    cover:
      "https://readdy.ai/api/search-image?query=Backstage%20of%20an%20outdoor%20music%20festival%2C%20drum%20kit%20and%20guitar%20cases%2C%20musicians%20in%20casual%20clothes%20talking%2C%20warm%20string%20lights%2C%20golden%20dusk%20sky%2C%20raw%20documentary%20music%20atmosphere&width=1200&height=760&seq=festival-backstage-x1&orientation=landscape",
    alt: "音乐节后台乐队休息的真实画面",
    author: "瓜姐",
    content: [
      "下午四点，距离乐队登台还剩三小时。调音师临时发现主舞台的鼓组与排练时的不一致，鼓手试了两下，情绪肉眼可见地垮了下来。他没有发火，只是安静地坐在设备箱上，把脸埋进手心。",
      "我们后来才知道，那套鼓是他职业生涯里一直用的老伙计，走音、破皮，却承载着太多记忆。一时间，整个后台都笼罩在低气压里。",
      "转机出现在十分钟后。同台的前辈乐手把自己的备用鼓组推了过来，什么也没说，只是拍拍鼓手的肩。鼓手愣了很久，然后突然笑了——那种笑里带着眼泪，比任何舞台上的嘶吼都有力量。",
      "至于那件被借走的演出服，起因是一位走错舞台的观众误入了后台。吉他手不仅没生气，反而把自己的签名T恤脱下来递给他：「既然来了，就穿这个上台看吧。」",
      "这些片段最终都没能出现在正片里。制作人说，它们太「碎」了，不适合节目节奏。可在我们看来，恰恰是这些没人愿意剪掉的失控瞬间，才让聚光灯下的音乐，有了可以触摸的温度。",
    ],
  },
  {
    id: "n07",
    slug: "drama-youth-series-ratings",
    title: "《那年盛夏》会员收官：青春剧如何摆脱「高开低走」魔咒",
    category: "热剧追踪",
    categorySlug: "drama",
    tag: "剧集盘点",
    date: "2026-09-02",
    views: 47600,
    comments: 610,
    hot: false,
    exclusive: false,
    summary:
      "从首播不被看好到结局登上热搜，《那年盛夏》用二十四集的克制，讲完了几个普通人的青春。主创团队复盘：不强行圆满，是它最勇敢的地方。",
    cover:
      "https://readdy.ai/api/search-image?query=Youth%20drama%20still%20scene%20of%20high%20school%20students%20on%20bicycles%20under%20summer%20trees%2C%20golden%20sunlight%20through%20leaves%2C%20school%20uniforms%2C%20nostalgic%20warm%20cinematic%20style%2C%20coming%20of%20age&width=1200&height=760&seq=drama-youth-x1&orientation=landscape",
    alt: "青春剧那年盛夏单车夏日画面",
    author: "老周",
    content: [
      "青春剧向来是爆款重灾区，也是烂尾高发区。而《那年盛夏》却在收官当晚，凭一场长达五分钟、没有任何BGM的对白戏冲上了热搜——这在当下的国产剧里几乎算得上「反常规」。",
      "编剧团队在复盘里坦言，前期他们收到过无数次「加戏」的反馈，希望男女主角的结局更圆满、更解气。但反复拉扯后，他们还是决定守住那份「遗憾」——因为真正的青春，从来不是没有遗憾，而是学会与遗憾和解。",
      "剧中的配角也并非工具人。那个总爱出风头的班长，毕业多年后在老家的早餐摊重新出现，简单两句对白，就把人物弧光补得完整。有评论说，这是难得连配角都「长出了自己的人生」的剧。",
      "导演说，他们最想拍的，其实是「那些没有成为大人物的普通人」。首播时很多人不看好这种「丧」气，可正是这份对普通人的尊重，让剧集在会员收官阶段逆势走高。",
      "高开低走是流量时代的宿命吗？《那年盛夏》用结局告诉我们：敢不敢把话说完整、把人物「放生」，才是一部剧最终能否立住的根本。",
    ],
  },
  {
    id: "n08",
    slug: "music-livehouse-chenmo",
    title: "独立乐队「沉默海岸」：在三平米酒吧，唱出十万人的孤独",
    category: "音乐现场",
    categorySlug: "music",
    tag: "现场记录",
    date: "2026-08-31",
    views: 38900,
    comments: 420,
    hot: false,
    exclusive: false,
    summary:
      "没有顶级音响，没有巨型屏幕，主唱甚至要和观众抢麦。但就是这间只能挤下五十人的地下酒吧，让在场所有人都跟着哼完了整张专辑。独立音乐的路，比想象中更野。",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20intimate%20underground%20livehouse%20concert%2C%20indie%20band%20on%20tiny%20stage%2C%20warm%20colored%20stage%20lights%2C%20audience%20silhouettes%20close%20together%2C%20smoky%20atmosphere%2C%20raw%20energetic%20music%20scene&width=1200&height=760&seq=music-livehouse-x1&orientation=landscape",
    alt: "独立乐队沉默海岸小型现场演出画面",
    author: "音浪编辑部",
    content: [
      "演出当晚八点，这间开在老城区的酒吧地下室里，已经站满了人。没有分区、没有座位，最前排的观众几乎要贴上舞台边缘的监听音箱。而台上的四人乐队「沉默海岸」，也只是刚刚结束白天的本职工作赶来。",
      "主唱在间隙里自嘲，说他们的音墙「也就够震碎这面墙」，可话音未落，前奏一起，全场五十个人便整齐地跟唱起来。没有提词器，没有荧光棒，只有合在一起的声音，在狭小的空间里来回碰撞。",
      "「沉默海岸」的作品大多关于漂泊与失眠，在流媒体上动辄数十万播放，可线下能容纳的，永远只有这几十张脸。贝斯手说，他们在网上听过太多「懂了」，反而是在这样近的距离里，才第一次看清那些听懂的人眼里的光。",
      "散场后，许多人迟迟不愿离开，围在吧台旁和乐队聊天。有人带着连夜从隔壁城市赶来的车票，有人红着眼眶请主唱在专辑内页签名。",
      "也许真正的孤独，从来不是没人听你的歌，而是你唱给十万人的声音，始终没有一个能落在同频的人肩上。而「沉默海岸」选择在三平米的酒吧里，把这件事一件件做回来。",
    ],
  },
  {
    id: "n09",
    slug: "variety-reality-show-formula",
    title: "《生活观察室》制作人自曝：真人秀的「真」，究竟被剪辑掉了多少",
    category: "综艺圈",
    categorySlug: "variety",
    tag: "深度对话",
    date: "2026-08-29",
    views: 52300,
    comments: 1890,
    hot: false,
    exclusive: false,
    summary:
      "「你以为看到的是全部，其实连十分之一都不到。」《生活观察室》制作人首次松口，聊起真人秀工业里那套被反复打磨的剧本、人设与「反转」。这场对话，可能让你重新看待所有综艺。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20tv%20studio%20control%20room%20with%20many%20screens%20showing%20people%20living%20in%20glass%20rooms%2C%20producers%20watching%2C%20cool%20professional%20lighting%2C%20documentary%20behind%20the%20scenes%20atmosphere&width=1200&height=760&seq=variety-studio-x1&orientation=landscape",
    alt: "综艺观察室导播间多屏监控画面",
    author: "阿岚",
    content: [
      "当「真人秀有剧本」早已成为公开的秘密时，《生活观察室》制作人王导还是决定把这场对话进行到底。在他看来，观众有权知道，他们看到的「真实」，究竟经过了怎样的加工。",
      "「我们确实会设定情境，比如第一天故意不准备足够的食材，观察嘉宾如何反应。」王导摊开手，「但没人能'演'出二十四个小时。剪辑只是放大，永远无法凭空捏造那些瞬间的情绪。」",
      "他承认，「人设」是这门生意绕不开的部分：「我们会引导嘉宾呈现更'有记忆点'的一面，但代价是，那些同样真实、却不够'好看'的迟疑与沉默，往往留在了剪辑室的地板上。」",
      "谈到最近爆出的某档节目「恶意剪辑」争议，王导语气罕见地严肃起来：「真人秀的底线，是不能为了冲突牺牲掉对人的基本尊重。剪刀可以有态度，但不能有恶意。」",
      "采访尾声，王导问了我们一个反客为主的问题：「如果所有综艺都放弃戏剧化、回归绝对真实，你们还愿意看吗？」这个没有标准答案的问题，或许才是理解真人秀的唯一钥匙。",
    ],
  },
  {
    id: "n10",
    slug: "star-debut-child-actor",
    title: "童星长大后的第一场成人戏：我们和「国民闺女」聊了聊转型焦虑",
    category: "明星动态",
    categorySlug: "stars",
    tag: "人物专访",
    date: "2026-08-27",
    views: 44500,
    comments: 980,
    hot: false,
    exclusive: false,
    summary:
      "六岁出道、被全国观众看着长大的「国民闺女」陈一朵，最近拍完了人生第一部真正的成人题材作品。转型是娱乐圈最残酷也最温柔的命题，她决定不装了。",
    cover:
      "https://readdy.ai/api/search-image?query=Young%20asian%20female%20actress%20in%20her%20twenties%20posing%20in%20a%20bright%20studio%2C%20soft%20natural%20window%20light%2C%20minimal%20beige%20background%2C%20confident%20yet%20thoughtful%20expression%2C%20editorial%20portrait%20photography&width=1200&height=760&seq=stars-portrait-x1&orientation=landscape",
    alt: "童星转型演员陈一朵的写真照",
    author: "小路",
    content: [
      "见到陈一朵时，她刚结束上一部戏的宣传，眼下还带着淡淡的青黑。这个六岁就出道、被全国人民看着长大的「国民闺女」，如今已经二十五岁，正准备迎接演员生涯最重要的一次转身。",
      "她上一部广为人知的作品，还是许多年前的儿童剧。中间几年，她刻意淡出，去读书、去旅行、去话剧舞台打磨。「我不想永远停在观众记忆里那个'乖巧女儿'的形象，那会毁了我。」她直截了当地说。",
      "转型的焦虑当然存在。试戏时被导演质疑「还是小时候那套演法」，是她最难堪的记忆之一。为了撕掉标签，她把剧本台词抄了整整五遍，对着镜子练习成年人那些「话说一半」的复杂情绪。",
      "「观众爱我，是因为我陪伴了他们。但我也需要被当作一个'新演员'重新认识。」她笑得坦诚，「哪怕这个过程会得罪一部分期待'她永远是小孩'的人，我也认了。」",
      "那部刚杀青的成人题材作品，或许会让她丢掉「国民闺女」的桂冠。但正如她自己所说，一个演员真正的成人礼，就是敢于让观众接受——她长大了。",
    ],
  },
];